import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation CreateStripeAPIKey($input: CreateStripeAPIKeyInput!) {
    createStripeAPIKey(input: $input) {
      id
      name
      secretKey
      publishableKey
    }
  }
`);

export default function useCreateStripeApi() {
  return useMutation(MUTATION, { refetchQueries: ['StripeAPIKeys'] });
}
